import * as url from '../util/url';
import request from '../util/request';
import validator from '../util/validator';
import ErrorType from '../constants/error-type';

const API_STAGE = '//api.stage.svt.se/videoplayer-api/video/';
const API_PROD = '//api.svt.se/videoplayer-api/video/';

export default function (videoId, callback, errorCallback) {
    let apiUrl = url.getQueryParameter('svtIsStage') === 'true' ? API_STAGE : API_PROD;
    apiUrl = url.getQueryParameter('apiPath') || apiUrl;

    request.getJson(apiUrl + videoId, (jsonData) => {
        let videoUrls = {};
        let textUrls = {};
        let videoRefs = jsonData.videoReferences || [];
        let textRefs = jsonData.subtitleReferences || [];

        videoRefs.forEach(function (item) {
            videoUrls[item.format] = item.url;
        });

        textRefs.forEach(function (item) {
            textUrls[item.format] = item.url;
        });

        const error = validator.validate(jsonData, videoUrls);
        if (error) {
            errorCallback(error, jsonData);
        } else {
            callback(jsonData, videoUrls, textUrls);
        }

    }, () => {
        errorCallback({ name: ErrorType.LOAD_ERROR });
    });
}



// WEBPACK FOOTER //
// ./src/js/api/default-metadata-fetch.js